var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-bottom":"5px","cursor":"pointer"},on:{"click":_vm.onChecked}},[_c('span',{staticClass:"checkbox glyphicon",class:{'active glyphicon-check': _vm.isCheck, 'glyphicon-unchecked': !_vm.isCheck},staticStyle:{"display":"inline"}}),_vm._v(" "),_c('span',{staticStyle:{"display":"inline"}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8926a9c2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/Checkbox.vue
// module id = null
// module chunks = 